var BufferPromptHandler = require('bufferprompthandler');


var ChannelPromptHandler = BufferPromptHandler.extend({
    bindMessageHandlers: function (options) {
        BufferPromptHandler.prototype.bindMessageHandlers.call(this, options);
        this.model.bind('topicPrompt', this.topicPrompt, this);
        this.model.bind('invitePrompt', this.invitePrompt, this);
        this.model.bind('banPrompt', this.banPrompt, this);
        this.model.bind('kickPrompt', this.kickPrompt, this);
        this.model.bind('renamePrompt', this.renamePrompt, this);
        this.model.bind('renameError', this.renameError, this);
        this.model.bind('deleteConfirm', this.deleteConfirm, this);
    },
    topicPromptText: function (topicLen) {
        var promptText = 'Set the topic for ' + this.model.getDisplayName();
        if (topicLen || topicLen === 0) {
            var s = Math.abs(topicLen) === 1 ? '' : 's';
            promptText += ' (' + topicLen + ' char' + s + ')';
        }
        return promptText;
    },
    topicText: function (text) {
        if (this.model.connection.isSlack()) {
            var prevEmojiTextMode = emoji.text_mode;
            emoji.text_mode = true;
            text = this.formatter.renderEmoji(text);
            emoji.text_mode = prevEmojiTextMode;
            return text;
        } else {
            return text;
        }
    },
    topicPrompt: function (callback) {
        var topicLen = this.model.connection.getISupport('TOPICLEN');
        var topicText = this.model.getTopic().getText();
        var currentTopicLen = topicLen;
        if (topicText) {
            currentTopicLen -= this.topicText(topicText).length;
        }
        var promptText = this.topicPromptText(currentTopicLen);
        var overlay = this.prompt(promptText, _.bind(function (topic) {
            this.model.updateTopic(topic);
            if (callback) {
                callback();
            }
        }, this), topicText, {
            onPromptKey: _.bind(function (e, input, textContainer) {
                textContainer.html(this.formatter.render(this.topicPromptText(topicLen - this.topicText(input.val()).length)));
            }, this)
        });
        overlay.className = 'channel_topic_prompt';
        this.triggerAdd(overlay);
    },
    invitePrompt: function (callback) {
        var badgesUrl = '/badges?' + $.param({
            hostname: this.model.connection.getHostname(),
            port: this.model.connection.getPort(),
            channel: this.model.getName(),
            ssl: this.model.connection.isSSL() ? '1': ''
        });
        var badgesLink = $('<a target="_blank">').attr('href', badgesUrl).text('links and badges');
        var promptHtml = $('<div>')
            .append($('<p>')
                .text("Invite someone to join " + this.model.getDisplayName() + '. To send an invite outside of IRC, try our ')
                .append(badgesLink));
        var overlay = this.htmlConfirm(promptHtml, _.bind(function (nick) {
            var user = this.model.connection.makeUserFromTarget(undefined, {
                nick: nick
            });
            user.invite(this.model.getName());
            if (callback) {
                callback();
            }
        }, this), {
            prompt: true,
            promptHint: 'Nickname'
        });
        overlay.className = 'channel_invite_prompt';
        this.triggerAdd(overlay);
    },
    banPrompt: function (user, callback) {
        var banmask = user.getBanMask(true);
        var overlay = this.prompt("Add a banmask for " + user.getDisplayName(), _.bind(function (newBanmask) {
            this.model.ban(newBanmask);
            if (callback) {
                callback();
            }
        }, this), banmask);
        overlay.className = 'channel_ban_prompt';
        this.triggerAdd(overlay);
    },
    kickPrompt: function (user, callback) {
        var overlay = this.prompt("Give a reason for kicking", _.bind(function (reason) {
            this.model.kick(user, reason);
            if (callback) {
                callback();
            }
        }, this));
        overlay.className = 'channel_kick_prompt';
        this.triggerAdd(overlay);
    },
    renameError: function (newName, response, callback) {
        var msg = '';
        switch (response.message) {
        case 'invalid_name':
            msg = 'You must choose a valid channel name';
            break;
        case 'not_channel':
            msg = 'You can only rename channels';
            break;
        case 'name_exists':
            msg = 'That name is already taken';
            break;
        case 'channel_joined':
            msg = 'You can only rename parted channels';
            break;
        default:
            msg = 'Error renaming: ' + response.message;
        }
        this.renamePrompt(newName, callback, msg);
    },
    renamePrompt: function (promptName, callback, error) {
        var promptText = "Choose a new name for this channel";
        var overlay = this.prompt(promptText, _.bind(function (newName) {
            this.model.rename(newName, callback);
        }, this), promptName, {
            error: error,
            keepFocus: false
        });
        overlay.className = 'channel_rename_prompt';
        this.triggerAdd(overlay);
    },
    deleteConfirm: function (callback) {
        var confirmText = "Are you sure you want to delete your history for " + this.model.getDisplayName();
        var overlay = this.confirm(confirmText, _.bind(function () {
            this.model.remove();
            if (callback) {
                callback();
            }
        }, this), {
            confirmClass: 'delete'
        });
        overlay.className = 'channel_delete_confirm';
        this.triggerAdd(overlay);
    }
});


module.exports = ChannelPromptHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/channelprompthandler.js
// module id = z+V+
// module chunks = 1